import ResetPasswordForm from "../components/reset-password-form/reset-password-form.component";

const ResetPassword = () => {
    return(
        <div>
            <ResetPasswordForm />
        </div>
    )
}

export default ResetPassword;